export const GET_DICTIONARY_REPORT_COMPANY_PERIOD = Symbol('GET_DICTIONARY_REPORT_COMPANY_PERIOD');
export const GET_DICTIONARY_REPORT_COMPANY_PERIOD_REQUEST = Symbol('GET_DICTIONARY_REPORT_COMPANY_PERIOD_REQUEST');
export const GET_DICTIONARY_REPORT_COMPANY_PERIOD_SUCCESS = Symbol('GET_DICTIONARY_REPORT_COMPANY_PERIOD_SUCCESS');
export const GET_DICTIONARY_REPORT_COMPANY_PERIOD_ERROR = Symbol('GET_DICTIONARY_REPORT_COMPANY_PERIOD_ERROR');

